import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationModule } from './authentication/authentication.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpService } from '../app/http.service';
import { DropdownToggleComponent } from './common-layout/navbar/dropdown-toggle/dropdown-toggle.component';
import { NotFoundModule } from './notfound/not-found.module';
import { HttpInterceptorService } from '../app/appServices/http-interceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { LeavingWebsiteComponent } from './leaving-website/leaving-website.component';
import { CommonLayoutModule } from './common-layout/common-layout.module';
import { AccountDetailComponent } from './account-detail/account-detail.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PipesModule } from './pipes/pipes.module';
import { TimeagoModule } from 'ngx-timeago';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LandingPageComponent } from './cloud-subscription/components/landing-page/landing-page.component';
import { PopupComponent } from './common-layout/popup/popup.component';
import { ViewSelectedPlanComponent } from './subscription-plans/view-selected-plan/view-selected-plan.component';
import { ShoppingCartModule } from './cloud-subscription/components/shopping-cart/shopping-cart.module';
import { EnvironmentsViewSingleModule } from './cloud-subscription/components/edit-environment/environment-view-single.module';
import { SelectPlanComponent } from './subscription-plans/select-plan/select-plan.component';
import { AvailablePlansComponent } from './subscription-plans/available-plans/savailable-plans.component';
import { NgIdleModule } from '@ng-idle/core';
import { NonHostedPreviewquotationComponent } from './paid-subscription/components/create-quotation/quotationforclient/nonhosted/previewquotation/previewquotation.component';

@NgModule({
  declarations: [
    AppComponent,
    DropdownToggleComponent,
    LeavingWebsiteComponent,
    AccountDetailComponent,
    LandingPageComponent,
    PopupComponent,
    SelectPlanComponent,
    ViewSelectedPlanComponent,
    AvailablePlansComponent,
  ],
  imports: [
    BrowserModule,
    NgIdleModule.forRoot(),
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    CommonLayoutModule,
    AuthenticationModule,
    NgbModule,
    FontAwesomeModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot(),
    NotFoundModule,
    PipesModule,
    ShoppingCartModule,
    EnvironmentsViewSingleModule,
    NgxSkeletonLoaderModule,
    TimeagoModule.forRoot()],
  providers: [
    HttpClientModule,
    HttpService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule { }
